var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPercentageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 257,
    viewBox: "0 0 257 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.073 0C153.746 3.0615e-07 178.827 7.71583 200.061 22.1463L182.064 48.628C166.139 37.8051 147.328 32.0183 128.073 32.0183V0Z",
    fill: "url(#paint0_linear_3479_279)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M203.365 24.4689C224.133 39.5617 239.886 60.5479 248.58 84.7044L218.453 95.5466C211.933 77.4292 200.118 61.6896 184.542 50.3699L203.365 24.4689Z",
    fill: "url(#paint1_linear_3479_279)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M249.69 87.9222C257.738 112.301 258.274 138.536 251.228 163.224L220.439 154.436C225.724 135.921 225.322 116.244 219.286 97.9599L249.69 87.9222Z",
    fill: "url(#paint2_linear_3479_279)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M250.108 166.934C242.318 191.396 227.356 212.954 207.163 228.808L187.391 203.624C202.535 191.733 213.757 175.566 219.599 157.218L250.108 166.934Z",
    fill: "url(#paint3_linear_3479_279)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M203.988 231.222C183.311 246.44 158.537 255.092 132.882 256.056L131.68 224.06C150.921 223.337 169.501 216.848 185.009 205.435L203.988 231.222Z",
    fill: "url(#paint4_linear_3479_279)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M128.927 256.146C103.254 256.146 78.1729 248.43 56.9391 234L74.936 207.518C90.8614 218.341 109.672 224.128 128.927 224.128V256.146Z",
    fill: "url(#paint5_linear_3479_279)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4652 232.171C32.5979 217.215 16.7071 196.333 7.85462 172.235L37.9092 161.194C44.5486 179.268 56.4667 194.93 72.1171 206.147L53.4652 232.171Z",
    fill: "url(#paint6_linear_3479_279)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53513 168.462C-1.56108 144.098 -2.14831 117.864 4.84964 93.1633L35.6555 101.891C30.407 120.417 30.8475 140.092 36.9196 158.365L6.53513 168.462Z",
    fill: "url(#paint7_linear_3479_279)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94142 89.517C13.6703 65.0348 28.5786 43.4404 48.7321 27.5359L68.5673 52.6702C53.4523 64.5986 42.271 80.7943 36.4743 99.156L5.94142 89.517Z",
    fill: "url(#paint8_linear_3479_279)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.08 24.982C72.7454 9.74863 97.5121 1.0776 123.166 0.0940238L124.393 32.0888C105.152 32.8265 86.5773 39.3297 71.0783 50.7548L52.08 24.982Z",
    fill: "url(#paint9_linear_3479_279)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3479_279",
    x1: 261.678,
    y1: -23.907,
    x2: 8.42057,
    y2: 255.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A95A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529388,
    stopColor: "#E8ECEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959649,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3479_279",
    x1: 261.678,
    y1: -23.907,
    x2: 8.42057,
    y2: 255.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A95A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529388,
    stopColor: "#E8ECEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959649,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3479_279",
    x1: 261.678,
    y1: -23.907,
    x2: 8.42057,
    y2: 255.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A95A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529388,
    stopColor: "#E8ECEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959649,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3479_279",
    x1: 261.678,
    y1: -23.907,
    x2: 8.42057,
    y2: 255.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A95A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529388,
    stopColor: "#E8ECEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959649,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3479_279",
    x1: 261.678,
    y1: -23.907,
    x2: 8.42057,
    y2: 255.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A95A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529388,
    stopColor: "#E8ECEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959649,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3479_279",
    x1: 262.531,
    y1: -23.907,
    x2: 9.27433,
    y2: 255.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A95A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529388,
    stopColor: "#E8ECEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959649,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3479_279",
    x1: 261.678,
    y1: -23.907,
    x2: 8.42057,
    y2: 255.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A95A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529388,
    stopColor: "#E8ECEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959649,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3479_279",
    x1: 261.678,
    y1: -23.907,
    x2: 8.42057,
    y2: 255.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A95A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529388,
    stopColor: "#E8ECEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959649,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3479_279",
    x1: 261.678,
    y1: -23.907,
    x2: 8.42057,
    y2: 255.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A95A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529388,
    stopColor: "#E8ECEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959649,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3479_279",
    x1: 261.678,
    y1: -23.907,
    x2: 8.42057,
    y2: 255.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A95A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529388,
    stopColor: "#E8ECEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959649,
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentageIcon);
export default __webpack_public_path__ + "static/media/percentageIcon.a147fd8361340146cc6739a7299eae53.svg";
export { ForwardRef as ReactComponent };